import { navigateTo, useNuxtApp } from '#imports';
import { AUTH } from '@/constants/common';
import { useAuth0 } from '@auth0/auth0-vue';
import { tryRecoverSession } from '@/utils/auth/session-recovery';

export async function useToken() {
  try {
    const nuxtApp = useNuxtApp();
    const auth0 = nuxtApp.runWithContext(() => useAuth0());
    const token = await auth0.getAccessTokenSilently();
    return token;
  } catch (e) {
    if (e.error === 'missing_refresh_token' || e.error === 'invalid_grant') {
      tryRecoverSession(() => navigateTo(AUTH.REDIRECT.LOGOUT));
    }
  }
}

export async function useSub() {
  try {
    const nuxtApp = useNuxtApp();
    const auth0 = nuxtApp.runWithContext(() => useAuth0());
    const sub = auth0?.user.value?.sub;
    return sub;
  } catch (e) {
    if (e.error === 'missing_refresh_token' || e.error === 'invalid_grant') {
      tryRecoverSession(() => navigateTo(AUTH.REDIRECT.LOGOUT));
    }
  }
}
